var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CEDB0D72-DBAA-4FC6-9CAB-37BB23B10600") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.823529 0 0 0 0 0.823529 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0.1-Dashboard---Menu-Preview",
    transform: "translate(-28.000000, -686.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 662.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.0893617,2.28316611 L22.8765957,2.28316611 C23.4782336,2.28316611 23.9659574,1.77206197 23.9659574,1.14158305 C23.9659574,0.511104143 23.4782336,0 22.8765957,0 L1.0893617,0 C0.487723847,0 0,0.511104143 0,1.14158305 C0,1.77206197 0.487723847,2.28316611 1.0893617,2.28316611 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8765957,6.84949833 L1.0893617,6.84949833 C0.487723847,6.84949833 0,7.36060247 0,7.99108138 C0,8.62156029 0.487723847,9.13266444 1.0893617,9.13266444 L22.8765957,9.13266444 C23.4782336,9.13266444 23.9659574,8.62156029 23.9659574,7.99108138 C23.9659574,7.36060247 23.4782336,6.84949833 22.8765957,6.84949833 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8765957,13.6989967 L1.0893617,13.6989967 C0.487723847,13.6989967 0,14.2101008 0,14.8405797 C0,15.4710586 0.487723847,15.9821628 1.0893617,15.9821628 L22.8765957,15.9821628 C23.4782336,15.9821628 23.9659574,15.4710586 23.9659574,14.8405797 C23.9659574,14.2101008 23.4782336,13.6989967 22.8765957,13.6989967 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu.a692335fbf4de5086b3d405815c88b0d.svg";